<template>
	<div>
		<Header current='souye' ref="Header"></Header>
		<div class="innoOne">
			<div class="innoOneOne">
				<div class="innoOneOneOne" @click="goCxpt()"></div>
				<div class="innoOneOneTwo" @click="goCxts()">{{title}}</div>
			</div>
			<div class="innoOneTwo">
				<div class="innoOneTwoOne" v-for="(item,index) in detail.bigTitle" :key="index">{{item.text}}</div>
				<!-- <div class="innoOneTwoTwo">答内镜图像「天花板」之问</div> -->
			</div>
			<div class="innoOneThree">
				<div class="innoOneThreeOne" v-for="(item,index) in detail.content" :key="index">{{item.text}}</div>
				<!-- 软镜像素的极限在哪里？ -->
			</div>
		</div>
		<template v-if="headerShow">
			<div class="innoNr">
				<div class="innoNrFor" v-for="(item,index) in detail.data" :key="index">
					<div class="innoNrForLeft" v-if="item.type==1">
						<div class="innoNrForLeftImg">
							<img :src="item.cover" />
						</div>
						<div class="innoNrForLeftWz" :style="{
						paddingRight: bj+'px',
					}">
							<div class="innoNrForLeftWzTil">
								{{item.title}}
							</div>
							<div class="innoNrForLeftWzCen">
								<div v-for="(itema,indexa) in item.desc" :key="indexa">{{itema.text}}</div>
							</div>
						</div>
					</div>
					<div v-else class="innoNrForRight">
						<div class="innoNrForRightWz" :style="{
						paddingLeft: bj+'px',
					}">
							<div class="innoNrForRightWzTil">
								{{item.title}}
							</div>
							<div class="innoNrForRightWzCen">
								<div v-for="(itema,indexa) in item.desc" :key="indexa">
									{{itema.text}}
								</div>
							</div>
						</div>
						<div class="innoNrForRightImg">
							<img :src="item.cover" />
						</div>
					</div>
				</div>
			</div>
		</template>
		<template v-else>
			<div class="innoNr">
				<div class="innoNrFor" v-for="(item,index) in detail.data" :key="index">
					<div class="innoNrForLeft" v-if="item.type==1">
						<el-row :gutter="10">
							<el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
								<div class="innoNrForLeftImg">
									<img :src="item.cover" />
								</div>
							</el-col>
							<el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
								<div class="innoNrForLeftWz" :style="{
											paddingRight: bj+'px',
										}">
									<div class="innoNrForLeftWzTil">
										{{item.title}}
									</div>
									<div class="innoNrForLeftWzCen">
										<div v-for="(itema,indexa) in item.desc" :key="indexa">{{itema.text}}</div>
									</div>
								</div>
							</el-col>
						</el-row>


					</div>
					<div v-else class="innoNrForRight">
						<el-row :gutter="10">
							<el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
								<div class="innoNrForRightWz" :style="{
									paddingLeft: bj+'px',
								}">
									<div class="innoNrForRightWzTil">
										{{item.title}}
									</div>
									<div class="innoNrForRightWzCen">
										<div v-for="(itema,indexa) in item.desc" :key="indexa">
											{{itema.text}}
										</div>
									</div>
								</div>
							</el-col>
							<el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
								<div class="innoNrForRightImg">
									<img :src="item.cover" />
								</div>
							</el-col>
						</el-row>


					</div>
				</div>
			</div>
		</template>
		

		<Footer></Footer>
	</div>
</template>

<script>
	import {
		hexinRead
	} from "@/api/innovation.js"
	import Header from "@/components/header.vue"
	import Footer from "@/components/footer.vue"
	export default {
		components: {
			Header,
			Footer,
		},
		data() {
			return {
				wbList: [{
						img: require('@/assets/innovation/tp4k.png'),
						title: '传统桎梏一锤打爆',
						cen: '内镜的光学系统离不开庞大的产业链支持及交叉学科创新。软镜图像画质在进入电子时代后，先后经历了SD、HD直到FHD的迭代。在技术的演进中，呈指数级增加的不仅是像素点，更是算法、硬件、软件、制造等多方面的难度。实现突破，意味着更前沿的理念推导，更扎实的软硬件支持和更丰富稳定的平台。近年来，澳华始终以4K超高清画质为核心目标，不断精进算法，打造高画质与高效率的平台，以3840*2160p的高分辨打破内镜图像现有的天花板。'
					},
					{
						img: require('@/assets/innovation/tp4k.png'),
						title: '传统桎梏一锤打爆',
						cen: '内镜的光学系统离不开庞大的产业链支持及交叉学科创新。软镜图像画质在进入电子时代后，先后经历了SD、HD直到FHD的迭代。在技术的演进中，呈指数级增加的不仅是像素点，更是算法、硬件、软件、制造等多方面的难度。实现突破，意味着更前沿的理念推导，更扎实的软硬件支持和更丰富稳定的平台。近年来，澳华始终以4K超高清画质为核心目标，不断精进算法，打造高画质与高效率的平台，以3840*2160p的高分辨打破内镜图像现有的天花板。'
					},
					{
						img: require('@/assets/innovation/tp4k.png'),
						title: '传统桎梏一锤打爆',
						cen: '内镜的光学系统离不开庞大的产业链支持及交叉学科创新。软镜图像画质在进入电子时代后，先后经历了SD、HD直到FHD的迭代。在技术的演进中，呈指数级增加的不仅是像素点，更是算法、硬件、软件、制造等多方面的难度。实现突破，意味着更前沿的理念推导，更扎实的软硬件支持和更丰富稳定的平台。近年来，澳华始终以4K超高清画质为核心目标，不断精进算法，打造高画质与高效率的平台，以3840*2160p的高分辨打破内镜图像现有的天花板。'
					},
					{
						img: require('@/assets/innovation/tp4k.png'),
						title: '传统桎梏一锤打爆',
						cen: '内镜的光学系统离不开庞大的产业链支持及交叉学科创新。软镜图像画质在进入电子时代后，先后经历了SD、HD直到FHD的迭代。在技术的演进中，呈指数级增加的不仅是像素点，更是算法、硬件、软件、制造等多方面的难度。实现突破，意味着更前沿的理念推导，更扎实的软硬件支持和更丰富稳定的平台。近年来，澳华始终以4K超高清画质为核心目标，不断精进算法，打造高画质与高效率的平台，以3840*2160p的高分辨打破内镜图像现有的天花板。'
					},
				],
				infoid: '',
				id: '',
				detail: '',
				title: '',
				bj: 140
			}
		},
		mounted() {
			this.id = this.$route.query.id;
			this.infoid = this.$route.query.infoId;
			this.getDetail();
			this.$refs.Header.headerTrue = true;
			this.$refs.Header.headerHover = true;
			this.getWidth();
		},
		methods: {
			getWidth() {
				console.log(document.body.clientWidth, window.screen.availWidth)
				let width = ''
				if (document.body.clientWidth > 1200) {
					width = document.body.clientWidth - 1200;
				} else {
					width = 0;
				}
				this.$nextTick(function() {
					this.bj = width / 2
				})
			},
			goCxpt() {
				// this.$router.push({
				// 	push:'/innovation',
				// 	name:'innovation',
				// 	query: { value:'cxpt'}
				// })
			},
			goCxts() {
				// this.$router.push({
				// 	push:'/innovation',
				// 	name:'innovation',
				// 	query: { value:'cxpt'}
				// })
			},
			getDetail() {
				let data = {
					id: this.id,
					info_id: this.infoid
				}
				hexinRead(data).then(res => {
					console.log(res)
					this.detail = res.data.info.details;
					this.title = res.data.info.title
				}).catch(err => {
					console.log(err)
				})
			}
		}
	}
</script>

<style>

</style>
<style scoped lang="scss">
	.innoOne {
		width: 1200px;
		margin: 0 auto;

		.innoOneOne {
			display: flex;
			align-items: center;
			margin-top: 111px;
			margin-bottom: 57px;

			>div {
				// cursor: pointer;
			}

			.innoOneOneOne {
				padding: 0 5px;
				min-width: 91px;
				height: 31px;
				background: #FFFFFF;
				border: 1px solid #000000;
				margin-right: 24px;
				font-size: 16px;
				
				font-weight: 300;
				color: #000000;
				display: flex;
				align-items: center;
				justify-content: center;
			}

			.innoOneOneTwo {
				padding: 0 5px;
				min-width: 91px;
				height: 31px;
				background: #FFFFFF;
				border: 1px solid #000000;
				margin-right: 24px;
				font-size: 16px;
				
				font-weight: 300;
				color: #000000;
				display: flex;
				align-items: center;
				justify-content: center;
			}
		}

		.innoOneTwo {
			// font-size: 45px;
			font-size: 36px;
			
			font-weight: bold;
			color: #010000;
			margin-bottom: 55px;

			>div:nth-of-type(1) {
				margin-bottom: 20px;
			}
		}

		.innoOneThree {
			font-size: 18px;
			
			font-weight: 400;
			color: #000000;
			margin-bottom: 148px;

			.innoOneThreeOne {
				margin-bottom: 10px;
			}
		}
	}

	.innoNr {
		.innoNrFor {
			min-width: 1200px;
			padding-bottom: 150px;

			.innoNrForLeft {
				display: flex;

				// align-items: center;
				// height: 500px;
				.innoNrForLeftImg {
					width: 50%;

					img {
						width: 100%;
						height: 500px;
						object-fit: cover;
					}
				}

				.innoNrForLeftWz {
					flex: 1;
					padding-left: 140px;

					// height: 500px;
					// overflow-y: auto;
					.innoNrForLeftWzTil {
						// font-size: 30px;
						font-size: 24px;
						
						font-weight: 400;
						color: #000000;
						width: 100%;
					}

					.innoNrForLeftWzCen {
						width: 100%;
						margin-top: 55px;
						font-size: 18px;
						
						font-weight: 400;
						color: #000000;
						text-align: justify;

						>div {
							margin-bottom: 10px;
						}
					}
				}
			}

			.innoNrForRight {
				display: flex;

				// align-items: center;
				// height: 500px;
				.innoNrForRightImg {
					width: 50%;

					img {
						width: 100%;
						height: 500px;
						object-fit: cover;
					}
				}

				.innoNrForRightWz {
					flex: 1;
					padding-right: 140px;

					// height: 500px;
					// overflow-y: auto;
					.innoNrForRightWzTil {
						// font-size: 30px;
						font-size: 24px;
						
						font-weight: 400;
						color: #000000;
						width: 100%;
					}

					.innoNrForRightWzCen {
						width: 100%;
						margin-top: 55px;
						font-size: 18px;
						
						font-weight: 400;
						color: #000000;
						text-align: justify;

						>div {
							margin-bottom: 10px;
						}
					}
				}
			}
		}
	}

	[lang]:lang(en) {
		.innoOneOneOne {
			padding: 0 10px;
			min-width: 94px;
			width: auto;
		}

		.innoOneOneTwo {
			width: auto;
			padding: 0 10px;
			min-width: 94px;
		}

	}

	@media screen and (max-width:1200px) {
		.innoOne {
			max-width: 100% !important;
			padding: 0 30px !important;
			box-sizing: border-box;

			.innoOneTwo {
				font-size: 24px !important;
				margin-bottom:30px !important;
			}
			.innoOneThree{
				margin-bottom:30px !important;
			}
		}

		.innoNrFor {
			width: 100% !important;
			padding: 0 30px !important;
			box-sizing: border-box;
		}
		
		.innoNrForLeftWz{
			padding:10px 0 !important;
			.innoNrForLeftWzTil{
				width:calc( 100vw - 60px) !important;
				font-size: 18px !important;
			}
			.innoNrForLeftWzCen{
				width:calc( 100vw - 60px) !important;
				margin-top: 30px !important;
				font-size: 14px !important;
				word-wrap: break-word;
				word-break: break-all;
			}
		}
		.innoNrForLeftImg{
			width:calc( 100vw - 60px) !important;
			
			img{
				height: auto !important;
				object-fit: contain !important;
			}
		}
		.innoNrForRightWz{
			padding:10px 0 !important;
			.innoNrForRightWzTil{
				width:calc( 100vw - 60px) !important;
				font-size: 18px !important;
			}
			.innoNrForRightWzCen{
				width:calc( 100vw - 60px) !important;
				margin-top: 30px !important;
				font-size: 14px !important;
				word-wrap: break-word;
				word-break: break-all;
			}
		}
		.innoNrForRightImg{
			width:calc( 100vw - 60px) !important;
			img{
				height: auto !important;
				object-fit: contain !important;
			}
		}
	}
</style>